import React from 'react';

import { save, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import MDScreen from './MDScreen';

const { headings } = vars;

export default {
  [ROUTES.masterData.name]: {
    screen: MDScreen,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Master Data</Text>,
    headerActions: [save],
  },
};
